// import { _deepClone } from '../../../helpers/utilities';
// import { writable } from 'svelte/store';
import type { ISceneObj } from '../../../types/SceneType';

// interface ISceneObj {
// 	id?: string | number; //on scene edit only
// 	_enabled: boolean;
// 	_run_on_ingest: boolean;
// 	_meta: {
// 		name: string;
// 		image: string;
// 		integrations: boolean;
// 		position?: number;
// 		room: number | string;
// 		roomn: string;
// 	};
// 	if: {
// 		or?: any[];
// 		and?: [or: any[], indailyint: unknown];
// 	};
// 	do: any[];
// }

// const create_scene_object = () => {
// 	let scene: ISceneObj = {
// 		_enabled: true,
// 		_run_on_ingest: true,
// 		_meta: {
// 			name: '',
// 			image: '',
// 			integrations: false,
// 			room: -1,
// 			roomn: '',
// 			position: -1
// 		},
// 		if: {
// 			or: []
// 		},
// 		do: []
// 	};
// 	const { subscribe, set, update } = writable(scene);

// 	return {
// 		subscribe,
// 		change: (newScene: ISceneObj) => {
// 			update((props: ISceneObj) => {
// 				props = _deepClone(newScene) as ISceneObj;
// 				return props;
// 			});
// 		},
// 		reset: () => set(scene)
// 	};
// };

// export const scene_object_prototype = create_scene_object();

export const scene_object_prototype: ISceneObj = {
	_enabled: true,
	_run_on_ingest: true,
	_meta: {
		name: '',
		image: '',
		integrations: false,
		room: -1,
		roomn: '',
		position: -1,
	},
	if: {
		or: [],
	},
	do: [],
};
